import axios from "@/util/basehttp";
import qs from "qs";

const pre = "/teacher/base";

const teacher = {
  teacherListPage(pageSize, limit, keyWord) {
    return axios.get(pre + `/teacherListPage`, {
      params: {
        pageSize: pageSize,
        limit: limit,
        keyWord: keyWord
      }
    });
  },

  teacherInfo(memberId) {
    return axios.get(pre + `/teacherInfo`, { params: { memberId: memberId } });
  },

  teacherResourcePageList(
    pageSize,
    limit,
    keyWord,
    fileType,
    resourceState,
    classId,
    subjectId,
    versionId,
    bookId,
    sectionId,
    sortName
  ) {
    return axios.get(pre + `/teacherResourcePageList`, {
      params: {
        pageSize: pageSize,
        limit: limit,
        keyWord: keyWord,
        fileType: fileType,
        resourceState: resourceState,
        classId: classId,
        subjectId: subjectId,
        versionId: versionId,
        bookId: bookId,
        sectionId: sectionId,
        sortName: sortName
      }
    });
  },

  teacherResourceInfo(id) {
    return axios.get(pre + `/teacherResourceInfo`, { params: { id: id } });
  },

  teacherResourceSave(params) {
    return axios.post(pre + `/teacherResourceSave`, qs.stringify(params));
  },
  teacherResourceDelete(id) {
    return axios.delete(pre + `/teacherResourceDelete`, { params: { id: id } });
  },
  uploadTeacherResourceZip(formData) {
    return axios.post(pre + "/uploadTeacherResourceZip", formData, {
      headers: {
        "Content-Type": "multipart/form-data;charset=utf-8"
      }
    });
  }
};
export default teacher;



// WEBPACK FOOTER //
// ./src/api/teacher/teacher.js